import { useState } from "react";
import { useApiData, fmtDateTime } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { StatusBadge } from "@/components/common/StatusBadge";
import { PageTitle } from "@/components/shell/DashboardShell";
import { RequestTable } from "@/components/portal/RequestTable";
import { RequestBody } from "@/pages/portal/Requests";
import { ExportButton, FilterBar, Pill, useQueryPath } from "@/components/admin/FilterBar";
import { StatusUpdater } from "@/components/admin/StatusUpdater";
import { REQUEST_STATUSES, REQUEST_TYPES, STATUS } from "@/data/portal";

const RequestDialog = ({ r, onClose, onSaved }) => (
  <Dialog open onOpenChange={onClose}>
    <DialogContent className="max-h-[92vh] max-w-5xl overflow-y-auto bg-[#F4F6F2]" data-testid="request-dialog">
      <DialogHeader>
        <DialogTitle className="flex flex-wrap items-center gap-3"><span className="mono text-base">{r.reference}</span> {r.subject} <StatusBadge status={r.status} /></DialogTitle>
        <p className="text-sm text-slate-500">{r.company_name} · {r.contact_name} · {r.email} · Raised {fmtDateTime(r.created_at)}</p>
      </DialogHeader>
      <StatusUpdater endpoint={`/admin/requests/${r.id}`} current={r.status} statuses={REQUEST_STATUSES} onSaved={onSaved} testid="request-status" />
      <RequestBody r={r} />
    </DialogContent>
  </Dialog>
);

export default function AdminRequests() {
  const [type, setType] = useState("all");
  const [status, setStatus] = useState("all");
  const [search, setSearch] = useState("");
  const [sel, setSel] = useState(null);
  const { data, reload } = useApiData(useQueryPath("/admin/requests", { type, status, search }));
  return (
    <div data-testid="admin-requests-page">
      <PageTitle eyebrow="Portal workflow" title="Vendor requests" text="AMC, warranty, order and service requests raised by approved vendors." action={<ExportButton path={useQueryPath("/admin/export/requests", { type, status, search })} filename={`vinsafe-requests-${new Date().toISOString().slice(0, 10)}.csv`} testid="export-requests-button" />} />
      <FilterBar search={search} setSearch={setSearch} testid="requests-admin-filter">
        {["all", ...Object.keys(REQUEST_TYPES)].map((k) => <Pill key={k} active={type === k} onClick={() => setType(k)} testid={`admin-requests-type-${k}`}>{k === "all" ? "All types" : REQUEST_TYPES[k].label}</Pill>)}
        <span className="mx-1 w-px bg-slate-300" />
        {["all", ...REQUEST_STATUSES].map((s) => <Pill key={s} active={status === s} onClick={() => setStatus(s)} testid={`admin-requests-status-${s}`}>{s === "all" ? "Any status" : STATUS[s].label}</Pill>)}
      </FilterBar>
      <RequestTable rows={data || []} showCompany onRowClick={setSel} />
      {sel && <RequestDialog r={sel} onClose={() => setSel(null)} onSaved={(d) => { setSel(d); reload(); }} />}
    </div>
  );
}
